module.exports = __webpack_public_path__ + "assets/img/icon-home-submission.103df846.png";